import React from "react";
import { Global, InterpolationWithTheme } from "@emotion/react";
import { theme } from "@styles/theme";
import { Theme } from "@theme-ui/css";
import { getThemeValue } from "@styles/utils/getThemeValue";

const htmlStyles: InterpolationWithTheme<Theme> = {
  ":focus": {
    outline: "none",
  },
  ":focus-visible": {
    // replace default outline styles with themed boxShadow
    outline: 0,
    boxShadow: `0 0 0 2px ${getThemeValue("colors.darkGray")}`,
  },
  html: {
    fontSize: "100%",
  },
  body: {
    fontFamily: theme.fonts?.["body"],
    fontSize: "1rem",
    color: theme.colors?.text,
  },
  p: {
    marginTop: 0,
    marginBottom: theme.space?.[4],
    lineHeight: theme.lineHeights?.["normal"],
  },
  b: {},
  i: {},
  em: {},
  strong: {
    fontFamily: theme.fonts?.["heading"],
    fontWeight: theme.fontWeights?.["regular"],
  },
  del: {},
  small: {
    fontSize: ".875em",
  },
  a: {
    color: theme.colors?.text,
    ":hover": {
      textDecoration: "none",
    },
  },
  "h1, h2, h3, h4, h5, h6": {
    fontFamily: theme.fonts?.["heading"],
    fontWeight: theme.fontWeights?.["regular"],
    marginTop: 0,
    marginBottom: theme.space?.[2],
  },
  h1: {
    fontSize: theme.fontSizes?.["h1"],
  },
  h2: {
    fontSize: theme.fontSizes?.["h2"],
  },
  h3: {
    fontSize: theme.fontSizes?.["h3"],
  },
  h4: {
    fontSize: theme.fontSizes?.["h4"],
  },
  h5: {
    fontSize: theme.fontSizes?.["h5"],
  },
  h6: {
    fontSize: theme.fontSizes?.["h6"],
  },
  img: {
    verticalAlign: "middle",
    borderStyle: "none",
    maxWidth: "100%",
    height: "auto",
  },
  "ol, ul, dl": {
    marginTop: 0,
    marginBottom: theme.space?.[4],
  },
  ol: {},
  ul: {},
  li: {},
  dl: {},
  dt: {
    fontFamily: theme.fonts?.["heading"],
  },
  dd: {},
  blockquote: {
    fontSize: theme.fontSizes?.["paragraphLarge"],
    margin: 0,
    marginBottom: theme.space?.[4],
  },
  hr: {
    marginTop: theme.space?.[4],
    marginBottom: theme.space?.[4],
    border: 0,
    borderTop: `${theme.borderWidths?.["1"]} solid ${theme.colors?.["muted"]}`,
  },
  table: {
    marginBottom: theme.space?.[4],
    borderCollapse: "collapse",
    width: theme.sizes?.["full"],
  },
  "table td, table th": {
    padding: theme.space?.["3"],
    verticalAlign: "top",
    borderTop: `${theme.borderWidths?.["1"]} solid ${theme.colors?.["muted"]}`,
  },
  tr: {},
  th: {
    textAlign: "inherit",
  },
  td: {},
};

const GlobalStyles: React.FC = () => {
  return <Global styles={{ ...htmlStyles }} />;
};

export { GlobalStyles };
